module.exports = require("@material-ui/core/Chip");